import script from "./richTextPage.vue?vue&type=script&setup=true&lang=js"
export * from "./richTextPage.vue?vue&type=script&setup=true&lang=js"

import "./richTextPage.vue?vue&type=style&index=0&id=e270e33a&scoped=true&lang=scss"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e270e33a"]])

export default __exports__